import {TranslateService} from '@ngx-translate/core';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {Doughnut} from '../../+postpayroll/check/key-metrics/charts/pie/doughnut';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {Payrolls} from '../../shared/utils/payrolls';
import {ChartBoxElement, DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

import {DashboardChartUtils} from './dashboard-chart.utils';

export class PayrollStatusChart extends Doughnut {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService) {
    const params = chartBox.params[Object.keys(chartBox.params)[0]];
    const chart: Chart = ChartUtils.getEmptyChart();
    const colors: string[] = [];

    params.forEach((element: ChartBoxElement) => {
      chart.data.push({
        category: Payrolls.getDisplayNameForStatus(element.name, translate),
        name: Payrolls.getDisplayNameForStatus(element.name, translate),
        value: element.value,
        metadata: element.link
      });
      colors.push(Payrolls.getColorForStatus(element.name));
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization);

    this.legend.orient = 'horizontal';
    this.legend.y = 'bottom';
    this.legend.x = 'center';
    this.series[0].center = ['50%', '45%'];
    this.series[0].radius = ['55%', '75%'];
    this.series[0].itemStyle.normal.label = {
      formatter: '{c}',
      distance: 0.1
    };
    this.color = colors;
    this.animation = true;
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);
  }
}
